import { findActuatorInBuildingsOrAssets } from '../../../pages/Facilities/utils';

export const findItemWithId = (item, assets, buildings, locations) => {
  if (!item.type && !item.is_indoor)
    return assets?.find(a => a.properties?.id === item.id);
  if (!item.type && item.is_indoor) {
    return {
      properties: buildings
        ?.flatMap(building => building.properties?.floors || [])
        .flatMap(floor => floor.zones || [])
        ?.find(zone => zone.id === item.zone)
        ?.assets.find(a => a.id === item.id),
    };
  }
  if (item.type === 'LOC')
    return locations?.find(a => a.properties?.id === item.id);
  if (item.type === 'BLD')
    return buildings?.find(a => a.properties?.id === item.id);
  if (item.type === 'FLR') {
    return {
      properties: buildings
        ?.find(a => a.properties?.id === item.parent)
        ?.properties.floors.find(a => a.id === item.id),
    };
  }
  if (item.type === 'ZON') {
    return {
      properties: buildings
        ?.flatMap(building => building.properties?.floors || [])
        .find(floor => floor.id === item.parent)
        ?.zones.find(zone => zone.id === item.id),
    };
  }
  if (item.type === 'ACTUATOR') {
    const actuator = findActuatorInBuildingsOrAssets(
      buildings,
      assets,
      item.id,
    );
    return {
      properties: actuator,
    };
  }
};
